import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { form, FormField, maxLength, minLength, pattern, required } from '@angular/forms/signals';
import { Router, RouterLink } from '@angular/router';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NfzBranchLookup } from '../../../../core/context/nhf-branch-lookup';
import { ServiceProviderTypeLookup } from '../../../../core/context/service-provider-type-lookup';
import { FieldErrorsComponent } from '../../../../shared/ui/components/field-error/field-error';
import { ServiceProviderData } from '../../dto/service-provider-data';
import { ServiceProvidersService } from '../../services/service-providers-service';

import { NzMessageService } from 'ng-zorro-antd/message';
import {
  AddServiceProviderWebRequest,
  ServiceProviderType,
} from '../../../../core/api/mhsConfigurationApiClient';
@Component({
  selector: 'app-service-provider-create',
  imports: [
    ReactiveFormsModule,
    FormField,
    NzCardModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzSelectModule,

    NzCheckboxModule,
    RouterLink,
    NzFlexModule,
    NzGridModule,
    NzDividerModule,
    NzIconModule,
    NzTagModule,
    CommonModule,
    NzAvatarModule,
    NzDropdownModule,
    FieldErrorsComponent,
  ],
  templateUrl: './service-provider-create.html',
  styleUrl: './service-provider-create.scss',
})
export class ServiceProviderCreateComponent {
  serviceProviderService = inject(ServiceProvidersService);
  router = inject(Router);
  messageService = inject(NzMessageService);
  isSubmitting = signal(false);
  submitted = signal(false);
  serviceProviderTypes = ServiceProviderTypeLookup.types;
  nfzBranchCodes = [{ code: '', name: 'Brak' }, ...NfzBranchLookup.branches];

  serviceProviderModel = signal<ServiceProviderData>({
    name: '',
    type: 'Private',
    regon: '',
    code: '',
    nhfBranchCode: '',
    description: '',
    taxId: '',
    phone: '',
    zip: '',
    place: '',
    street: '',
    registryNumber: '',
  });

  serviceProviderForm = form(this.serviceProviderModel, (serviceProviderModel) => {
    required(serviceProviderModel.name);
    minLength(serviceProviderModel.name, 2, {
      message: 'Nazwa musi mieć przynajmniej 2 znaki',
    });
    maxLength(serviceProviderModel.name, 100, {
      message: 'Nazwa nie może mieć więcej niż 100 znaków',
    });
    required(serviceProviderModel.type);
    required(serviceProviderModel.regon);
    minLength(serviceProviderModel.regon, 9, {
      message: 'REGON musi mieć od 9 do 14 cyfr',
    });
    maxLength(serviceProviderModel.regon, 14, {
      message: 'REGON musi mieć od 9 do 14 cyfr',
    });
    pattern(serviceProviderModel.regon, /^\d+$/, {
      message: 'REGON musi składać się wyłącznie z cyfr',
    });
    required(serviceProviderModel.taxId);
    minLength(serviceProviderModel.taxId, 10, {
      message: 'NIP musi mieć 10 cyfr',
    });
    maxLength(serviceProviderModel.taxId, 10, {
      message: 'NIP musi mieć 10 cyfr',
    });
    pattern(serviceProviderModel.taxId, /^\d+$/, {
      message: 'NIP musi składać się wyłącznie z cyfr',
    });
    required(serviceProviderModel.phone);
    minLength(serviceProviderModel.phone, 9, {
      message: 'Numer telefonu musi mieć przynajmniej 9 cyfr',
    });
    maxLength(serviceProviderModel.phone, 12, {
      message: 'Numer telefonu nie może mieć więcej niż 12 cyfr',
    });
    pattern(serviceProviderModel.phone, /^\d+$/, {
      message: 'Numer telefonu musi składać się wyłącznie z cyfr',
    });
    required(serviceProviderModel.zip);
    pattern(serviceProviderModel.zip, /^\d{2}-\d{3}$/, {
      message: 'Niepoprawny format kodu pocztowego (XX-XXX)',
    });

    required(serviceProviderModel.place);
    minLength(serviceProviderModel.place, 2, {
      message: 'Nazwa miejscowości musi mieć przynajmniej 2 znaki',
    });
    maxLength(serviceProviderModel.place, 100, {
      message: 'Nazwa miejscowości nie może mieć więcej niż 100 znaków',
    });
    required(serviceProviderModel.street);
    minLength(serviceProviderModel.street, 2, {
      message: 'Nazwa ulicy musi mieć przynajmniej 2 znaki',
    });
    maxLength(serviceProviderModel.street, 100, {
      message: 'Nazwa ulicy nie może mieć więcej niż 100 znaków',
    });
  });

  mapToApiModel(formValue: ServiceProviderData): AddServiceProviderWebRequest {
    var apiModel = new AddServiceProviderWebRequest();

    apiModel.name = formValue.name;
    apiModel.type = formValue.type == 'Nhf' ? ServiceProviderType.Nhf : ServiceProviderType.Private;
    apiModel.regon = formValue.regon;
    apiModel.code = formValue.code;
    apiModel.nhfBranchCode = formValue.nhfBranchCode;
    apiModel.description = formValue.description;
    apiModel.taxId = formValue.taxId;
    apiModel.phone = formValue.phone;
    apiModel.zip = formValue.zip;
    apiModel.place = formValue.place;
    apiModel.street = formValue.street;
    apiModel.registryNumber = formValue.registryNumber;
    return apiModel;
  }
  submit() {
    this.submitted.set(true);

    if (this.serviceProviderForm().valid()) {
      this.isSubmitting.set(true);
      this.serviceProviderService
        .create(this.mapToApiModel(this.serviceProviderModel()))
        .subscribe(
          (result) => {
            this.messageService.success('Podmiot został utworzony');
            this.router.navigate(['/service-providers', result.id, 'details']);
          },
          (error) => {
            console.error('Error creating user:', error);
          },
        )
        .add(() => {
          this.isSubmitting.set(false);
        });
    } else {
      this.isSubmitting.set(false);
    }
  }
}
